// extracted by mini-css-extract-plugin
export default {"button":"StatusBad_button__Jdhx3"};